import { render, staticRenderFns } from "./EditGtinModal.vue?vue&type=template&id=3b371416&scoped=true&"
import script from "./EditGtinModal.vue?vue&type=script&lang=js&"
export * from "./EditGtinModal.vue?vue&type=script&lang=js&"
import style0 from "./EditGtinModal.vue?vue&type=style&index=0&id=3b371416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b371416",
  null
  
)

export default component.exports